module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--01.14759ec3.png";